'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * 드롭을 전면 차단하는 훅.
 * 로컬 파일 등 지원하지 않는 페이로드가 드래그되면
 * dropEffect='none'으로 금지 커서를 표시하고 drop 이벤트를 막는다.
 */
export function useBlockDrop() {
  const $ = _c(9);
  const [isBlocked, setIsBlocked] = useState(false);
  const enterCountRef = useRef(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => {
      e.preventDefault();
      enterCountRef.current = enterCountRef.current + 1;
      if (enterCountRef.current === 1) {
        setIsBlocked(true);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onDragEnter = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e_0 => {
      e_0.preventDefault();
      enterCountRef.current = enterCountRef.current - 1;
      if (enterCountRef.current <= 0) {
        enterCountRef.current = 0;
        setIsBlocked(false);
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onDragLeave = t1;
  const onDragOver = _temp;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_2 => {
      e_2.preventDefault();
      enterCountRef.current = 0;
      setIsBlocked(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onDrop = t2;
  let t3;
  let t4;
  if ($[3] !== isBlocked) {
    t3 = () => {
      if (!isBlocked) {
        return;
      }
      const reset = () => {
        enterCountRef.current = 0;
        setIsBlocked(false);
      };
      window.addEventListener("dragend", reset);
      window.addEventListener("drop", reset);
      window.addEventListener("blur", reset);
      return () => {
        window.removeEventListener("dragend", reset);
        window.removeEventListener("drop", reset);
        window.removeEventListener("blur", reset);
      };
    };
    t4 = [isBlocked];
    $[3] = isBlocked;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      onDragEnter,
      onDragLeave,
      onDragOver,
      onDrop
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isBlocked) {
    t6 = {
      blockDropProps: t5,
      isBlocked
    };
    $[7] = isBlocked;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(e_1) {
  e_1.preventDefault();
  e_1.dataTransfer.dropEffect = "none";
}